import AxiosInstance from "services/api";

export const ConsignmentSettlementService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/consignment-settlement", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/consignment-settlement/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/consignment-settlement", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/consignment-settlement/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/consignment-settlement/${id}`);
  },
};
